// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_12Ct9GG","h5Text":"_2bHFTBd","h4Text":"_3FC_2Xr","h3Text":"_3CRkJ_v","srOnly":"_1U-EGC7","link":"_3K3gXHj _12Ct9GG","germanVATInc":"vsg1v2I"};